/**
 * API по базовым справочникам АМЛ.
 * API по базовым справочникам АМЛ.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Данные записи справочника КГРКО.
 */
export interface QrefFArx { 
    /**
     * namef
     */
    namef?: string;
    /**
     * nam
     */
    nam?: string;
    /**
     * adres
     */
    adres?: string;
    /**
     * telefon1
     */
    telefon1?: string;
    /**
     * adresp
     */
    adresp?: string;
    /**
     * numpsrf
     */
    numpsrf?: string;
    /**
     * numpsrb
     */
    numpsrb?: string;
    /**
     * adresf
     */
    adresf?: string;
    /**
     * rnbn
     */
    rnbn?: number;
    /**
     * rnfl
     */
    rnfl?: number;
    /**
     * country
     */
    country?: number;
    /**
     * datal
     */
    datal?: string;
    /**
     * datareg
     */
    datareg?: string;
}

